import { render } from "./ManageUserGroup.vue?vue&type=template&id=6e18e3b1"
import script from "./ManageUserGroup.vue?vue&type=script&lang=js"
export * from "./ManageUserGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__